import { useState } from "react";
import { T } from "../theme";

export default function Input({
  icon: Icon,
  label,
  textarea = false,
  value,
  onChange,
  placeholder,
  type = "text",
  style,
  ...rest
}) {
  const [focused, setFocused] = useState(false);

  const inputStyle = {
    width: "100%",
    padding: Icon ? T.inputPaddingWithIcon : T.inputPadding,
    fontSize: 14,
    fontFamily: T.fontBody,
    fontWeight: 400,
    color: T.textHi,
    background: focused ? T.bgCard : T.bgInput,
    border: focused ? `1px solid ${T.accent}` : "1px solid transparent",
    borderRadius: T.inputRadius,
    boxShadow: focused ? `0 0 0 3px ${T.accentDim}` : "none",
    outline: "none",
    transition: T.transitionFast,
    resize: textarea ? "vertical" : undefined,
    minHeight: textarea ? 100 : undefined,
    ...style,
  };

  const Comp = textarea ? "textarea" : "input";

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {label && (
        <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: T.textMid, marginBottom: 6, fontFamily: T.fontBody }}>
          {label}
        </label>
      )}
      <div style={{ position: "relative" }}>
        {Icon && (
          <Icon
            size={18}
            color={focused ? T.accent : T.textLow}
            style={{
              position: "absolute",
              left: 14,
              top: textarea ? 14 : "50%",
              transform: textarea ? "none" : "translateY(-50%)",
              transition: T.transitionFast,
              pointerEvents: "none",
            }}
          />
        )}
        <Comp
          type={textarea ? undefined : type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={inputStyle}
          {...rest}
        />
      </div>
    </div>
  );
}
